import { Grid } from "@mui/material";
import React from "react";
import { ActionButton } from "./Action";
const RightMenuToggle = (props) => {
    const onClick = () => {
        props.appModel.appState.setRightMenuOpen(true);
    };
    return (React.createElement(Grid, { item: true },
        React.createElement(ActionButton, { title: props.appModel.i18n("action.title.info"), hovercolor: props.appModel.theme.primaryColor, id: "iconRight", onClick: onClick, style: {
                paddingLeft: "0px",
                width: "36px",
                height: "36px",
            } },
            React.createElement("span", null,
                React.createElement("div", { className: "navbar-right" },
                    React.createElement("div", { className: "navbar-toggler menuRightToggler", style: { paddingLeft: "11px" } },
                        React.createElement("span", null),
                        React.createElement("span", null),
                        React.createElement("span", null)))))));
};
export default RightMenuToggle;
